import CryptoJS from 'crypto-js';

const secretKey = 'Yallabob151';

export const encryptData = (data) => {
    try {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    } catch (error) {
        console.error('Encryption error:', error);
        return null;
    }
};
export const decryptData = (cipherText) => {
    try {
        if (!cipherText) {
            throw new Error('No cipher text provided');
        }
        const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
        const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        if (!decryptedData) {
            throw new Error('Decryption error: Unable to parse decrypted data');
        }
        return JSON.parse(decryptedData);
    } catch (error) {
        console.error('Decryption error:', error);
        return null;
    }
};

// export const decryptData = (cipherText) => {
//     try {
//         const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
//         const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
//         return JSON.parse(decryptedData);
//     } catch (error) {
//         console.error('Decryption error:', error);
//         return null;
//     }
// };
